"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_1 = require("react");
var object_1 = require("@devexperts/utils/dist/object");
var RenderRemoteData = /** @class */ (function (_super) {
    tslib_1.__extends(RenderRemoteData, _super);
    function RenderRemoteData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderRemoteData.prototype.render = function () {
        var data = this.props.data;
        return (React.createElement(react_1.Fragment, null,
            data.isPending() && this.renderPending(),
            data.isSuccess() && this.renderSuccess(data.value),
            data.isFailure() && this.renderFailure(data.error)));
    };
    RenderRemoteData.prototype.renderPending = function () {
        var DataStatePending = this.props.DataStatePending;
        return React.createElement(DataStatePending, null);
    };
    RenderRemoteData.prototype.renderSuccess = function (data) {
        var _a = this.props, noData = _a.noData, success = _a.success, DataStateNoData = _a.DataStateNoData;
        if (object_1.isNotNullable(noData) && noData(data)) {
            return React.createElement(DataStateNoData, null);
        }
        return success(data);
    };
    RenderRemoteData.prototype.renderFailure = function (error) {
        var DataStateFailure = this.props.DataStateFailure;
        console.warn('[RemoteFailure]', error);
        return React.createElement(DataStateFailure, { error: error });
    };
    return RenderRemoteData;
}(react_1.Component));
exports.RenderRemoteData = RenderRemoteData;
//# sourceMappingURL=render-remote-data.component.js.map